<script>
    import FirstSlide from './slides/FirstSlide.svelte';
    import Motivation from './slides/Motivation.svelte';
    import SFC from "./slides/SFC.svelte";
    import Method from "./slides/Method.svelte";
    import Evaluation from "./slides/Evaluation.svelte";
    import Limitations from "./slides/Limitations.svelte";
    import End from "./slides/End.svelte";
</script>


<FirstSlide />
<Motivation />
<SFC />
<section />
<Method />
<Evaluation />
<Limitations />
<End />
